<template>
    <div class="template-C">
        <template v-for="(item, index) in data">
            <img v-if="item.icon" :key="index" :src="item.icon" @click="handleClick(item)" />
        </template>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array
        }
    },
    data() {
        return {}
    },
    methods: {
        handleClick(item) {
            if (item.jump_type == 1) {
                if (item.is_home == 1) {
                    this.$router.push({
                        path: '/detailIframe',
                        query: {
                            url: item.content_url,
                            isHome: item.is_home,
                            id: this.$route.query.id
                        }
                    })
                } else {
                    window.location.href = item.content_url
                }
            } else {
                this.$router.push({
                    path: '/detail',
                    query: {
                        id: item.id,
                        isHome: item.is_home
                    }
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.template-C {
    padding-bottom: 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    > img {
        width: 86%;
        &:not(:first-child) {
            margin-top: 0.6rem;
        }
    }
}
</style>
